export const AdPlayIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='58'
      height='63'
      viewBox='0 0 58 63'
      fill='none'
    >
      <g filter='url(#filter0_d_14636_271210)'>
        <path
          d='M47.5714 22.8157C49.4762 23.7865 49.4762 26.2135 47.5714 27.1843L13.2857 44.6583C11.381 45.6291 9 44.4156 9 42.4741L9 7.52593C9 5.58437 11.381 4.37089 13.2857 5.34167L47.5714 22.8157Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_14636_271210'
          x='-5'
          y='0'
          width='68'
          height='68'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='9' />
          <feGaussianBlur stdDeviation='4.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_14636_271210'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_14636_271210'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}
